import { Reducer } from "redux";
import { MasterPayerResponse } from "../models/api/Master";
import { MasterPayersDispatchTypes } from "../models/dispatchTypes/Master";
import { MasterPayerActionDispatchTypes } from "../constants/Master";

const initialState: MasterPayerResponse = {
  loading: false,
  response: [],
  error: null,
};

const MasterPayerReducer: Reducer<
  MasterPayerResponse,
  MasterPayersDispatchTypes
> = (state = initialState, action) => {
  switch (action.type) {
    case MasterPayerActionDispatchTypes.MASTER_PAYER_INVOKE: {
      return {
        ...state,
        loading: true,
      };
    }
    case MasterPayerActionDispatchTypes.MASTER_PAYER_SUCCESS: {
      return {
        ...state,
        response: action.response,
        loading: false,
      };
    }
    case MasterPayerActionDispatchTypes.MASTER_PAYER_ERROR: {
      return initialState;
    }
  }
  return state;
};

export default MasterPayerReducer;
